import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

  showTag;
  private subscription: Subscription;
  constructor(private loaderService: LoaderService) { }

  ngOnInit() {

    this.subscription = this.loaderService.getLoader()
      .subscribe(show => {
        this.showTag = show;
      });

  }



  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
